<div *ngIf="switchingToExternalIOT" class="page-title fill-darkblue">
  You are being redirected to your online banking service. Please wait...
</div>

<ng-container *ngIf="!switchingToExternalIOT">
  <a class="button-close" (click)="closeDialog()">
    <i class="material-icons fill-nightfall" [hidden]="!fundAccountPart3 || !fundAccountPart2 || !tradeConfirmation"> close </i>
  </a>
  <div class="modal-box" *ngIf="!tradeConfirmation">
    <div class="dialog-title row">
      You are about to execute the following trade in the live market
    </div>
    <div class="content">
      <div class="row row-item">
        <div class="col-12 col-md-8 left-panel">
          <div class="top-text col-12 ">
            Buy
          </div>
          <div class="d-flex">
            <div class="col-5 form-input currency">
              <span class="{{ modalModel.currencyCodeBuy.code | flagIcon }}"></span>&nbsp; {{ modalModel?.currencyCodeBuy.code }}
              <img class="icon-arrow ml-auto" src="./assets/images/icon-png/icon-arrow.png" alt="" />
            </div>
            <div class="col-7 form-input amount">
              {{ modalModel?.buyAmount | number: '1.2-2' }}
            </div>
          </div>
        </div>
        <div class="col-4 right-panel d-none d-md-block">
          <div class="top-text col-12 ">
            Exchange Rate
          </div>
          <div class="d-flex form-input">
            {{ modalModel?.exchangeRate | number: '1.2-6' }}
          </div>
        </div>
      </div>

      <!-- Row 2 -->
      <div class="row row-item">
        <div class="col-12 col-md-8 left-panel">
          <div class="top-text col-12 ">
            Pay with
          </div>
          <div class="d-flex">
            <div class="col-5 form-input currency">
              <span class="{{ modalModel?.currencyCodePay.code | flagIcon }}"></span>&nbsp; {{ modalModel?.currencyCodePay.code }}
              <img class="icon-arrow ml-auto" src="./assets/images/icon-png/icon-arrow.png" alt="" />

            </div>
            <div class="col-7 form-input amount">
              {{ modalModel?.payAmount | number: '1.2-2' }}
            </div>
          </div>
        </div>
        <div class="col-4 right-panel d-none d-md-block">
          <div class="top-text col-12 ">
            Exchange Fee (%)
          </div>
          <div class="d-flex form-input">
            {{ modalModel?.exchangeFee | number: '1.2-2' }}
          </div>
        </div>
      </div>

      <div class="d-md-none row-item row">
        <div class="col-6 d-left-panel">
          <div class="top-text col-12 ">
            Exchange Rate
          </div>
          <div class="d-flex form-input">
            {{ modalModel?.exchangeRate | number: '1.2-6' }}
          </div>
        </div>
        <div class="col-6 d-right-panel">
          <div class="top-text col-12 ">
            Exchange Fee (%)
          </div>
          <div class="d-flex form-input">
            {{ modalModel?.exchangeFee | number: '1.2-2' }}
          </div>
        </div>
      </div>

      <!-- Row 3 -->
      <div class="row-item row">
        <div class="col-12 d-flex top-text">
          Pay {{brandName}} by
          <br />
          <div class="img ml-auto">
            <img class="icon-info ml-auto" src="./assets/images/icon-png/icon-info-white.svg" alt="" />
            <span class="send-payment-tooltip tooltip-date tooltip-left">{{brandName}} should receive your funds no later than the date specified.
              <br> The account details for where to pay {{brandName}} are provided on your trade confirmation.</span>
          </div>
        </div>
        <div class="col-12 d-flex form-input">
          {{ modalModel?.valueDate }}
          <div class="ml-auto">
            <img class="icon-info ml-auto" src="./assets/images/icon-png/calendar_icon.svg" alt="" />

          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-12 px-0 term-condition">
          By continuing you will be bound by the terms and conditions in the
          <a href="https://www.{{domain}}/terms-of-use-website/" target="_blank" class="hyper-link">
            Client Trading Agreement
          </a>
        </div>
      </div>

      <div class="row">
        <div class="col-6 col-md-4 pl-0">
          <button class="btn btn-block btn-greengo-o btn-lg" (click)="cancelBookTrade()">Cancel</button>
        </div>
        <div class="col-6 col-md-4 ml-auto pr-0">
          <app-debounce-button
            [label]="'Continue'" 
            (onClick)="continue()"
            [timer]="timer"
            npFocusOutClicked></app-debounce-button>
        </div>
      </div>
    </div>
  </div>

  <div class="modal-box" *ngIf="!fundAccountPart2">
    <div class="dialog-title row">
      <strong>Transaction Confirmation </strong>
    </div>
    <div class="content">
      <div class="row row-item">
        <div class="col-12 col-md-8 left-panel">
          <div class="top-text col-12 ">
            You Sold
          </div>
          <div class="d-flex">
            <div class="col-5 form-input currency">
              <span class="{{ modalModel?.currencyCodePay.code | flagIcon }}"></span>&nbsp; {{ modalModel?.currencyCodePay.code }}
            </div>
            <div class="col-7 form-input amount">
              {{ modalModel?.payAmount | number: '1.2-2' }}
            </div>
          </div>
        </div>
        <div class="col-4 right-panel d-none d-md-block">
          <div class="top-text col-12 ">
            Your Exchange Rate
          </div>
          <div class="d-flex form-input">
            {{ modalModel?.exchangeRate | number: '1.2-6' }}
          </div>
        </div>
      </div>

      <!-- Row 2-->

      <div class="row row-item">
        <div class="col-12 col-md-8 left-panel">
          <div class="top-text col-12 ">
            You Bought
          </div>
          <div class="d-flex">
            <div class="col-5 form-input currency">
              <span class="{{ modalModel?.currencyCodeBuy.code | flagIcon }}"></span>&nbsp; {{ modalModel?.currencyCodeBuy.code }}
            </div>
            <div class="col-7 form-input amount">
              {{ modalModel?.buyAmount | number: '1.2-2' }}
            </div>
          </div>
        </div>
        <div class="col-4 right-panel d-none d-md-block ">
          <div class="top-text col-12 ">
            Value Date
          </div>
          <div class="d-flex form-input">
            {{ modalModel?.valueDate }}
          </div>
        </div>
      </div>

      <div class="row row-item d-md-none">
        <div class="col-6 d-left-panel">
          <div class="top-text col-12 ">
            Your Exchange Rate
          </div>
          <div class="d-flex form-input">
            {{ modalModel?.exchangeRate | number: '1.2-6' }}
          </div>
        </div>
        <div class="col-6 d-right-panel">
          <div class="top-text col-12 ">
            Value Date
          </div>
          <div class="d-flex form-input">
            {{ modalModel?.valueDate }}
          </div>
        </div>
      </div>

      <!-- Row 3 -->
      <div class="row row-item">
        <div class="left-panel your-reference" [ngClass]="{
          'col-5 col-md-6': !modalModel?.showDeposited,
          'col-6 col-md-4': modalModel?.showDeposited
        }">
          <div class="top-text col-12 ">
            Your Reference
          </div>
          <div class="d-flex form-input">
            {{ modalModel?.tradeReference }}
          </div>
        </div>

        <div class="col-6 col-md-4 middle-panel" *ngIf="modalModel?.showDeposited">
          <div class="top-text col-12 ">
            Deposit Required
          </div>
          <div class="d-flex form-input">
            {{ modalModel?.deposited }}%
          </div>
        </div>

        <div class="right-panel" [ngClass]="{
          'col-7 col-md-6 d-right-panel': !modalModel?.showDeposited,
          'col-12 col-md-4': modalModel?.showDeposited
        }">
          <div class="top-text col-12 ">
            Pay {{brandName}}
          </div>
          <div class="d-flex">
            <div class="col-5 form-input currency">
              <span class="{{ modalModel?.currencyCodePay.code | flagIcon }}"></span>&nbsp; {{ modalModel?.currencyCodePay.code }}
            </div>
            <div class="col-7 form-input amount">
              {{ modalModel?.payAmount | number: '1.2-2' }}
            </div>
          </div>
        </div>
      </div>

      <div class="row mt-4">
        <div class="col-8 col-md-6 pl-0 btn-download-contract">
          <button class="btn btn-block btn-lg btn-action" (click)="exportExcel()" npFocusOutClicked>
            Download PDF Contract Note
          </button>
        </div>
        <div class="col-4 ml-auto pr-0">
          <button class="btn btn-block btn-lg btn-greengo" (click)="nextPart2()" npFocusOutClicked>
            Next
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- Step 3 -->
  <div class="fund-account-part-3 modal-box" *ngIf="!fundAccountPart3">
    <div class="row dialog-title" *ngIf="data.iotInfo.redirectedFromIOT === false || data.iotInfo.processedOkIOT === false">
      <strong>Next Step | Please pay {{brandName}}</strong>
      <span></span>
    </div>

    <div class="row page-title mb-4" *ngIf="data.iotInfo.redirectedFromIOT === true && data.iotInfo.processedOkIOT === false">
      <span style="color: #ff0000">Failed to proceed with instant payment.
        <br>Please use the following information to pay {{brandName}} instead.</span>
    </div>

    <div class="row page-title fill-darkblue mb-4" *ngIf="data.iotInfo.redirectedFromIOT === true && data.iotInfo.processedOkIOT === true">
      <span>Instant payment submitted successfully.
        <br>Please click 'Pay Beneficiary' to pay your beneficiary or click 'Finish' to return to the dashboard.</span>
    </div>

    <div class="row" *ngIf="data.iotInfo.redirectedFromIOT === false || data.iotInfo.processedOkIOT === false">
      <div class="box-info">

        <div class="row">
          <div class="col-6 left-box">
            <div class="box pt-0">
              <span class="box-title">Account name</span>
              <span class="box-content">{{ fasterPaymentData?.accountName }}&nbsp;</span>
            </div>
          </div>
          <div class="col-6">
            <div class="box pt-0">
              <span class="box-title">IBAN</span>
              <span class="box-content">{{ fasterPaymentData?.iban }}&nbsp;</span>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-6 left-box">
            <div class="box">
              <span class="box-title">Bank name</span>
              <span class="box-content">{{ fasterPaymentData?.bankName }}&nbsp;</span>
            </div>
          </div>
          <div class="col-6">
            <div class="box">
              <span class="box-title">SWIFT CODE</span>
              <span class="box-content">{{ fasterPaymentData?.swiftCode }}&nbsp;</span>
            </div>
          </div>
        </div>

        <ng-container *ngIf="!data.isForwardTrade || (data.isForwardTrade && (!modalModel.deposited || modalModel.deposited <= 0))">
          <div class="row">
            <div class="col-6 left-box">
              <div class="box">
                <span class="box-title">Sort code</span>
                <span class="box-content">{{ fasterPaymentData?.sortCode }}&nbsp;</span>
              </div>
            </div>
            <div class="col-6">
              <div class="box">
                <span class="box-title">Balance due</span>
                <span class="box-content"> {{ modalModel?.currencyCodePay.code }} {{ modalModel?.payAmount | number: '1.2-2' }}</span>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-6 left-box">
              <div class="box">
                <span class="box-title">Account number</span>
                <span class="box-content">{{ fasterPaymentData?.accountNumber }}&nbsp;</span>
              </div>
            </div>
            <div class="col-6">
              <div class="box">
                <span class="box-title">Due date</span>
                <span class="box-content" *ngIf="!data.isForwardTrade">{{ modalModel?.valueDate }}</span>
                <span class="box-content" *ngIf="data.isForwardTrade">{{ balanceDueDate | date : 'dd/MM/yyyy' }}</span>
              </div>
            </div>
          </div>
        </ng-container>

        <ng-container *ngIf="data.isForwardTrade && modalModel.deposited && modalModel.deposited> 0">
          <div class="row d-md-flex d-none">
            <div class="col-6 left-box">
              <div class="box">
                <span class="box-title">Sort code</span>
                <span class="box-content">{{ fasterPaymentData?.sortCode }}&nbsp;</span>
              </div>
            </div>
            <div class="col-6">
              <div class="box">
                <div class="row">
                  <div class="col-7 pr-0">
                    <span class="box-title">Deposit due</span>
                    <br>
                    <span class="box-content">{{ modalModel?.currencyCodePay.code }} {{depositAmount | transformNumber}}</span>
                  </div>
                  <div class="col-5 px-0">
                    <span class="box-title">Due date</span>
                    <br>
                    <span class="box-content">{{ depositDueDate | date : 'dd/MM/yyyy' }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="row d-md-flex d-none">
            <div class="col-6 left-box">
              <div class="box">
                <span class="box-title">Account number</span>
                <span class="box-content">{{ fasterPaymentData?.accountNumber }}&nbsp;</span>
              </div>
            </div>
            <div class="col-6">
              <div class="box">
                <div class="row">
                  <div class="col-7 pr-0">
                    <span class="box-title">Balance due</span>
                    <br>
                    <span class="box-content">{{ modalModel?.currencyCodePay.code }} {{balanceAmount | transformNumber}}</span>
                  </div>
                  <div class="col-5 px-0">
                    <span class="box-title">Due date</span>
                    <br>
                    <span class="box-content">{{ balanceDueDate | date : 'dd/MM/yyyy' }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="row d-md-none d-flex">
            <div class="col-6 left-box">
              <div class="box">
                <span class="box-title">Sort code</span>
                <span class="box-content">{{ fasterPaymentData?.sortCode }}&nbsp;</span>
              </div>
            </div>
            <div class="col-6">
              <div class="box">
                <span class="box-title">Account number</span>
                <span class="box-content">{{ fasterPaymentData?.accountNumber }}&nbsp;</span>
              </div>
            </div>
          </div>

          <div class="row d-md-none d-flex">
            <div class="col-6 left-box">
              <div class="box">
                <span class="box-title">Deposit due</span>
                <span class="box-content">{{ modalModel?.currencyCodePay.code }} {{depositAmount | transformNumber}}</span>
              </div>
            </div>
            <div class="col-6">
              <div class="box">
                <span class="box-title">Due date</span>
                <span class="box-content">{{ depositDueDate | date : 'dd/MM/yyyy' }}</span>
              </div>
            </div>
          </div>

          <div class="row d-md-none d-flex">
            <div class="col-6 left-box">
              <div class="box">
                <span class="box-title">Balance due</span>
                <span class="box-content">{{ modalModel?.currencyCodePay.code }} {{balanceAmount | transformNumber}}</span>
              </div>
            </div>
            <div class="col-6">
              <div class="box">
                <span class="box-title">Due date</span>
                <span class="box-content">{{ balanceDueDate | date : 'dd/MM/yyyy' }}</span>
              </div>
            </div>
          </div>
        </ng-container>
      </div>
    </div>

    <div class="row mt-4" *ngIf="buyCurrencyMandate">
      <div class="pl-0" *ngIf="!data.iotInfo.redirectedFromIOT">
        <button class="btn btn-dimension btn-greengo-o px-0" (click)="goBack()">
          Back
        </button>
      </div>
      <div class="ml-auto">
        <button class="btn btn-dimension btn-greengo" (click)="payRecipient()" npFocusOutClicked>
          Next
        </button>
      </div>
    </div>

    <ng-container *ngIf="!buyCurrencyMandate">
      <div class="d-md-block d-none">
        <div class="row mt-4">
          <div class="pl-0" *ngIf="!data.iotInfo.redirectedFromIOT">
            <button class="btn btn-dimension btn-greengo-o px-0" (click)="goBack()">
              Back
            </button>
          </div>
          <div class="ml-auto mr-4">
            <button class="btn btn-dimension btn-dark-blue" (click)="payRecipient()" npFocusOutClicked>
              Pay Beneficiary
            </button>
          </div>
          <button class="btn btn-dimension btn-greengo" (click)="finish()">
            Finish
          </button>
        </div>
      </div>

      <div class="d-md-none d-block">
        <div class="row mt-4">
          <div class="pl-0" *ngIf="!data.iotInfo.redirectedFromIOT">
            <button class="btn btn-dimension btn-lead-50 px-0" (click)="goBack()">
              Back
            </button>
          </div>
          <div class="ml-auto">
            <button class="btn btn-dimension btn-dark-blue" (click)="payRecipient()" npFocusOutClicked>
              Pay Beneficiary
            </button>
          </div>
        </div>
        <div class="row mt-2">
          <div class="ml-auto">
            <button class="btn btn-dimension btn-greengo" (click)="finish()">
              Finish
            </button>
          </div>
        </div>
      </div>

    </ng-container>
  </div>
</ng-container>